import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SitecorePopularBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { TimerModule } from '../../../timers/timer.module';
import { PodEventsModel } from '../../popular-bets.models';

@Component({
    selector: 'ms-popular-bets-pod-header',
    templateUrl: './popular-bets-pod-header.component.html',
    styleUrl: './popular-bets-pod-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, TimerModule, IconCustomComponent],
})
export class PopularBetsPodHeaderComponent {
    @Input() isEpcotEnabled: boolean;
    @Input() pod: PodEventsModel;

    constructor(public sitecorePopularBetsConfig: SitecorePopularBetsConfig) {}
}
